import React from "react";
import { Card, Col, Row, Spinner } from "react-bootstrap";

interface InfoCardProps {
    bgColor: string;
    title: string;
    value: React.ReactNode;
    subtitle: string;
    online?: boolean;
}

const InfoCard: React.FC<InfoCardProps> = ({
    bgColor,
    title,
    value,
    subtitle,
    online = false,
}) => {
    return (
        <Col sm={12} md={3} className="mb-3">
            <Card bg={bgColor} text="white" border="none" className={`bg-theme-${bgColor}`}>
                <Card.Body className="text-left">
                    <small>{title}</small>
                    <Row>
                        <Col style={{ fontSize: "24px" }}>
                            <p dangerouslySetInnerHTML={{ __html: value }} />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex align-items-center m-auto">
                            <span style={{ fontSize: 11 }}>
                                <p dangerouslySetInnerHTML={{ __html: subtitle }} />
                            </span>
                        </Col>
                        {online &&
                            <Col xs={4} className="d-flex align-items-center justify-content-end m-auto" style={{ fontSize: 10 }}>
                                <Spinner animation="grow" variant="success" size="sm" />
                                <span className="ms-2">Online</span>
                            </Col>
                        }
                    </Row>
                </Card.Body>
            </Card>
        </Col>
    );
};

export default InfoCard;
